// extracted by mini-css-extract-plugin
export default {"greenLight":"#b9e0b5","card":"Media_card__nEmZt","media":"Media_media__T-cO-"};